import { render, staticRenderFns } from "./viewPhotos.vue?vue&type=template&id=070cc357&scoped=true&"
import script from "./viewPhotos.vue?vue&type=script&lang=js&"
export * from "./viewPhotos.vue?vue&type=script&lang=js&"
import style0 from "./viewPhotos.vue?vue&type=style&index=0&id=070cc357&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070cc357",
  null
  
)

export default component.exports